import { secondsInMonth, secondsInWeek } from 'date-fns'
import { maxUint256 } from 'viem'

export const MAX_REWARD_TOKENS = 3

export const REWARD_PERIODS = [
  { label: 'Per Month', value: 'monthly', seconds: secondsInMonth },
  { label: 'Per Week', value: 'weekly', seconds: secondsInWeek },
]

export type RewardPeriod = (typeof REWARD_PERIODS)[number]['value']

export const UNLIMITED_CAP = '-1'
export const MAX_UINT256 = maxUint256.toString()
export const DEFAULT_DECIMALS = 18
